import React, { useEffect, useState, useRef } from "react";
import { quizMap } from "../../utils/quizMap";
import { useParams, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setQuizData,
  nextQuestion,
  selectAnswer,
  showTheResult,
  incrementMarks,
} from "../../store-app/slices/InterviewSlice";

import Card from "react-bootstrap/Card";
import Result from "../Result";
import "./quiz.css";

const QUESTION_TIME = 10;

const Quiz = () => {
  const dispatch = useDispatch();
  const { type } = useParams();

  const { quizData: questions, currentQuestionIndex, userAnswers, showQuiz } =
    useSelector((state) => state.quiz);

  const [timeLeft, setTimeLeft] = useState(QUESTION_TIME);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!type || !quizMap[type]) return;
    dispatch(setQuizData(quizMap[type]));
  }, [type, dispatch]);

  useEffect(() => {
    if (!showQuiz || questions.length === 0) return;

    clearInterval(intervalRef.current);
    setTimeLeft(QUESTION_TIME);

    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [currentQuestionIndex, showQuiz, questions.length]);

  useEffect(() => {
    if (timeLeft <= 0) {
      clearInterval(intervalRef.current);

      if (userAnswers[currentQuestionIndex] === undefined) {
        dispatch(selectAnswer(null));
      }

      if (currentQuestionIndex < questions.length - 1) {
        dispatch(nextQuestion());
      }

      setTimeLeft(QUESTION_TIME);
    }
  }, [timeLeft, dispatch, currentQuestionIndex, userAnswers, questions.length]);

  if (!type || !quizMap[type]) {
    return <Navigate to="/" replace />;
  }

  const currentQuestion =
    questions && questions.length > 0 ? questions[currentQuestionIndex] : null;

  const handleAnswer = (selected) => {
    if (!currentQuestion || userAnswers[currentQuestionIndex] !== undefined)
      return;

    clearInterval(intervalRef.current);

    dispatch(selectAnswer(selected));

    if (selected === currentQuestion.answer) {
      dispatch(incrementMarks(5));
    }

    setTimeout(() => {
      if (currentQuestionIndex < questions.length - 1) {
        dispatch(nextQuestion());
      }
    }, 500);
  };

  const handleShowResult = () => {
    clearInterval(intervalRef.current);
    dispatch(showTheResult());
  };

  const timerPercent = (timeLeft / QUESTION_TIME) * 100;

  return (
    <main>
      {showQuiz ? (
        <div className="center pt-78">
          <div className="col-lg-8">
            <Card className="p-4 bg-dark border-0 card-content">
              {/* Timer */}
              <div className="mb-3 progress-container">
                <div className="d-flex justify-content-between text-light">
                  <span>⏱ Time</span>
                  <strong>{timeLeft}s</strong>
                </div>

                <progress
                  value={timerPercent}
                  max={100}
                  aria-label={`Time remaining: ${timeLeft} seconds`}
                  className="w-100"
                  style={{ height: "20px" }}
                />
              </div>

              <h5 className="text-light mb-3 question-text">
                {currentQuestion?.question}
              </h5>

              <ul className="list-unstyled quiz-options">
                {currentQuestion?.options?.map((option, index) => {
                  const userAnswer = userAnswers[currentQuestionIndex];
                  const isSelected = userAnswer === option;
                  const isCorrect = option === currentQuestion?.answer;

                  let btnClass = "btn-design light";
                  if (userAnswer !== undefined && userAnswer !== null) {
                    if (isSelected && isCorrect) btnClass += " success";
                    if (isSelected && !isCorrect) btnClass += " danger";
                  }

                  return (
                    <li key={index} className="mt-3">
                      <button
                        disabled={userAnswer !== undefined}
                        className={`w-100 ${btnClass}`}
                        onClick={() => handleAnswer(option)}
                      >
                        {option}
                      </button>
                    </li>
                  );
                })}
              </ul>

              {currentQuestionIndex + 1 === questions.length &&
              userAnswers[currentQuestionIndex] !== undefined ? (
                <button
                  onClick={handleShowResult}
                  className="btn btn-primary w-100 mt-3 show-result-btn"
                >
                  Show Result
                </button>
              ) : (
                <div className="show-result-placeholder"></div>
              )}
            </Card>
          </div>
        </div>
      ) : (
        <Result type={type} />
      )}
    </main>
  );
};

export default Quiz;
